import { CustomButton, Tabs } from '@medtronic/pecc-react-component-library-js';
import { Box, Typography } from '@mui/material';
import BreadcrumbsNavigation from '~/components/BreadcrumbsNavigation';
import { usePersistedTab } from '~/hooks';
import { useDatasetsTable } from '~/hooks/dataset';
import { HomeIcon } from '~/icons';
import { useAppDispatch, useAppSelector } from '~/redux';
import { selectCurrentUserApplicationRole } from '~/redux/slices/currentUserSlice';
import { ModalTypesEnum, openModal } from '~/redux/slices/modalSlice';
import { PageTabsKeyEnum } from '~/redux/slices/pageTabsSlice';
import { getPriviligies } from '~/utils';
import { DatasetsTable } from './components';
import { DatasetAccessTables } from './types';

const DataCatalogPage = () => {
  const dispatch = useAppDispatch();
  const userApplicationRole = useAppSelector(selectCurrentUserApplicationRole);
  const hasPermissions = getPriviligies(userApplicationRole);

  const allTableState = useDatasetsTable(DatasetAccessTables.ALL);
  const myDatasetsTableState = useDatasetsTable(DatasetAccessTables.MY_DATASETS);
  const approvedTableState = useDatasetsTable(DatasetAccessTables.APPROVED);

  const tabsData = [
    {
      label: `All datasets (${allTableState.rowCount ?? 0})`,
      value: DatasetAccessTables.ALL,
      content: <DatasetsTable {...allTableState} />,
      visible: hasPermissions?.dataset.canView,
    },
    {
      label: `My datasets (${myDatasetsTableState.rowCount ?? 0})`,
      value: DatasetAccessTables.MY_DATASETS,
      content: <DatasetsTable {...myDatasetsTableState} />,
      visible: hasPermissions?.dataset.canView,
    },
    {
      label: `Access approved (${approvedTableState.rowCount ?? 0})`,
      value: DatasetAccessTables.APPROVED,
      content: <DatasetsTable {...approvedTableState} />,
      visible: hasPermissions?.dataset.canView,
    },
  ];

  const visibleTabs = tabsData.filter((tab) => tab.visible);
  const { selectedTabIndex, handleTabChange } = usePersistedTab(PageTabsKeyEnum.DATA_CATALOG, visibleTabs);

  return (
    <>
      <BreadcrumbsNavigation
        navigationConfig={[
          { name: <HomeIcon />, path: '' },
          { name: 'Data catalog', path: '.' },
        ]}
      />
      <Box display="flex" justifyContent="space-between" alignItems="center" mb="3rem">
        <Typography variant="h3">Data Catalog</Typography>
        <CustomButton
          sx={{ '& span': { textTransform: 'none' } }}
          label="New dataset"
          onClick={() => dispatch(openModal({ type: ModalTypesEnum.CREATE_DATASET }))}
          buttonType="addNew"
        />
      </Box>
      <Tabs
        width="100%"
        labelSx={{ textTransform: 'none' }}
        tabsData={visibleTabs}
        redirectTabIndex={selectedTabIndex}
        setRedirectTabIndexOnChange={handleTabChange}
      />
    </>
  );
};

export default DataCatalogPage;
